import {noop} from 'lodash';
import React from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {
  ComposerPanelId,
  ViewerPanelId,
} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {useInteractiveListOnCancel} from '../../../../../../libs/shared/ui/src/components/dropdowns/quickInsert/quickInsertCommon';
import {BoundsRectProvider} from '../../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {SchedulingLinkModel} from '../../../../../models/api/schedulingLinkModel';
import {SchedulingLinksDropdownContainer} from '../../../../inboxes/composer/scheduling/schedulingLinksDropdownContainer';

/*
 * Props.
 */

interface QuickInsertSchedulingDropdownProps {
  panelId: ComposerPanelId | ViewerPanelId;
  anchor: BoundsRectProvider;
  onBack: () => void;
  onCancel: () => void;
  onSchedulingLinkInsertLink: (model: SchedulingLinkModel) => void;
}

/*
 * Component.
 */

export const QuickInsertSchedulingDropdown = (props: QuickInsertSchedulingDropdownProps) => {
  const [onRequestClose, onSchedulingLinkInsertLink] = useInteractiveListOnCancel(
    props.onCancel,
    props.onSchedulingLinkInsertLink,
  );

  return (
    <SchedulingLinksDropdownContainer
      isQuickInsert
      panelId={props.panelId}
      backButtonLabel={<Trans id="quick-insert-scheduling-link-back">Back</Trans>}
      anchor={props.anchor}
      onBackButtonClick={props.onBack}
      onInsertMeetingTimes={noop}
      onSchedulingLinkInsertLink={onSchedulingLinkInsertLink}
      onRequestClose={onRequestClose}
    />
  );
};
